import LoyaltyCard from "./LoyaltyCard";

export default LoyaltyCard;
